module.exports = "/images/vendor/desiigner-svg/svg/ui/chevron-left.svg?b9303073f4f4af2ecc027d8c5ee70b89";